import React, { useEffect, useState, useCallback } from "react";

import ChallengeLeaderboard from "../../../components/contests/challengeLeaderboard/challengeLeaderboard.component";
import useContestSettings from "../../../hooks/useContestSettings";
import useAppContext from "../../../hooks/useAppContext";

const LeaderboardWrapper = () => {
  const { axios } = useAppContext();
  const {
    data: { slug },
  } = useContestSettings();
  const [leaderboard, setLeaderboard] = useState([]);

  const fetchLeaderboards = useCallback(() => {
    axios
      .get(`contests/${slug}/leaderboard`)
      .then((res) => {
        setLeaderboard(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [slug]);

  useEffect(() => {
    fetchLeaderboards();
  }, [slug]);

  return (
    <>{leaderboard.length > 0 && <ChallengeLeaderboard data={leaderboard} />}</>
  );
};

export default LeaderboardWrapper;
